module.exports = __webpack_public_path__ + "static/media/cardmeditation.d7b2890a.jpg";